import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { auth, provider, signInWithPopup } from "../firebase";
import { selectUserName, selectUserPhoto, setSignOutState, setUserLoginDetails } from "../features/users/userSlice";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { signOut } from "@firebase/auth";

const Header = (props) => {
    
    const [show, handleShow] = useState(false);
    const [burgerStatus, setBurgerStatus] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();
    const userName = useSelector(selectUserName);
    const userPhoto = useSelector(selectUserPhoto);
    console.log(userPhoto);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if(window.scrollY > 100){
                handleShow(true);
            }
            else handleShow(false);
        })
    }, [])

    useEffect(()=>{
        auth.onAuthStateChanged(async (user)=>{
            if(user){
                setUser(user);
                // history.push("/")
            }
        });
    }, [userName]);

    const handleAuth =()=>{
        if(!userName){
            signInWithPopup(auth,provider).then((result)=>{
                setUser(result.user);
            }).catch(error=>{
                alert(error);
                console.log(error);
            });
        }else if(userName){
            signOut(auth,provider).then(()=>{
                dispatch(setSignOutState());
                history.push('/');
            }
            ).catch(error=>{
                alert(error.message);
            })
        }
        
    }

    const setUser = (user) =>{
        dispatch(
            setUserLoginDetails({
            name: user.displayName,
            email: user.email,  
            photo: user.photoURL,
        })
        );
    };


    return(
        <Navigation>
            <Navbar className = {`${show && "nav_slick"}`}>
                <Logo href="/">
                    <h3 className="header-logo">Winn<span className="red">thako</span></h3>
                </Logo>
                <NavMenu>
                    <Link to = '/'>Home</Link>
                    <Link to = '/about'>About</Link>
                    <Link to = '/services'>Services</Link>
                    <Link to = '/loans'>Loans</Link>
                    <Link to = '/blog'>Blog</Link>
                    <Link to = '/team'>Team</Link>
                    <Link to ='/contact'>Contact</Link> 
                </NavMenu>
                <Apply>

                    {
                    !userName ? <ApplyLink onClick={handleAuth}>Log In</ApplyLink>:  
                    
                    <div className="row">
                        <ApplyLink className="signOutBtn" onClick={handleAuth}>Sign Out</ApplyLink>
                        <UserImg src={userPhoto} alt = {userName} className="userImage"/>
                    </div> 
                    }
                    
                   
                    <MenuToggler onClick={() => setBurgerStatus(true)} show={burgerStatus}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </MenuToggler>
                    <CustomCloseBtn onClick={() => setBurgerStatus(false)} show={burgerStatus}>
                        <span><i class="fa fa-times" aria-hidden="true"></i></span>
                    </CustomCloseBtn>
                </Apply>
            </Navbar>

            <BurgerNav show={burgerStatus}>
                <Link to = '/'>Home</Link>
                <Link to = '/about'>About</Link>
                <Link to = '/services'>Services</Link>
                <Link to = '/loans'>Loans</Link>
                <Link to = '/blog'>Blog</Link>
                <Link to = '/team'>Team</Link>
                <Link to ='/contact'>Contact</Link> 
            </BurgerNav>
        </Navigation>
    )
}

const CustomCloseBtn =styled.div`
    span{
        font-size: 20px;
        cursor: pointer;
        display:  ${props => props.show ? 'inline-block':'none'};
        margin-left: 25px;
        
    }
`
const BurgerNav = styled.nav`
    position: fixed;
    top: 10;
    right: 0;
    height: fit-content;
    width: 100%;
    background: white;
    z-index: 2;
    transform: ${props => props.show ? 'translateY(0%)':'translateY(-200%)'};
    transition: transform 0.5s ease-in-out;
    
    a{
        display: block;
        color: rgb(136, 144, 169);
        font-family: "roboto", sans-serif;
        font-size: 15px;
        font-weight: 400;
        padding: 10px 20px;
        border-bottom: 1px solid rgb(219, 238, 253);
    }
    a:last-child{
        border: none;
    }
    

`


const Navigation =styled.div`
    .nav_slick{
        position: fixed;
        width: 100vw;
    }
    position: relative;
`
const Navbar = styled.nav`
    display: flex;
    justify-content: space-between;
    padding: 20px;
    height: 10vh;
    align-items: center;
    z-index: 2;
    background: rgb(255, 255, 255);
    opacity: 1;

    @media(max-width:768px){
        padding: 10px;
    }
`

const Logo = styled.a`
    flex: 1;

    @media(max-width: 768px){
       img{
           width: 120px;
           object-fit: contain;
       }
    
    }
`

const NavMenu = styled.div`
    display: flex;
    justify-content: space-between;
    flex: 2;
    a{
        color: rgb(32, 33, 36);
    }
    
    @media(max-width: 768px){
        display: none;
    }

`

const Apply = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    align-items: center;

    @media(max-width: 768px){
        justify-content: end;
    
    }
`


const MenuToggler = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    display:  ${props => props.show ? 'none':'flex'};
    
    @media(min-width:768px){
        display: none;
    }

    span{
        display: inline-block;
        width: 40px;
        height: 4px;
        background: black;
        margin-bottom: 5px;
        border-radius: 5px;

        @media(max-width: 768px){
            width: 20px;
            height: 2px;
        }
    }

`

const ApplyLink = styled.a`
    background: rgb(231, 60, 62);
    padding: 10px 40px;
    color: white;
    display: inline-block;
    margin-right: 20px;
    border-radius: 5px;
    cursor: pointer;
    height: 100%;

    @media(max-width: 768px){
        padding: 10px 5px;
        
    }
`
const UserImg = styled.img`

    border-radius: 50%;
    height: 50px;
    display: block;
    margin: auto 0;
    cursor: pointer;

    @media(max-width: 768px){
        height: 30px;
        margin-right: 3px;
    }

`
export default Header